// extracted by mini-css-extract-plugin
export default {"popover":"AppsButton_popover__K5PhD","header":"AppsButton_header__fI3gK","appButton":"AppsButton_appButton__pwQjG","auditorIcon":"AppsButton_auditorIcon__dVkNQ"};